
function onCategoryChange(select) {
    var value = select.value;
    var baseUrl = select.getAttribute("data-base-url");

    if (value) {
        window.location.href = baseUrl + '?category=' + encodeURIComponent(value);
    } else {
        window.location.href = baseUrl;
    }
}

document.addEventListener("DOMContentLoaded", function () {

    var customOptions = document.querySelectorAll(".custom-select .options li");
    var select = document.getElementById("realSelect");

    if (!select || !customOptions.length) return;

    customOptions.forEach(function (option) {
        option.addEventListener("click", function () {

            var value = option.getAttribute("data-value");

            // 1. update the real select
            select.value = value;

            // 2. trigger your logic manually
            onCategoryChange(select);
        });
    });

});

document.addEventListener("DOMContentLoaded", function () {

    var select = document.getElementById("realSelect");
    var valueSpan = document.querySelector(".custom-select .value");

    if (!select || !valueSpan) return;

    // Get selected option text
    var selectedOption = select.options[select.selectedIndex];

    if (selectedOption) {
        valueSpan.innerText = selectedOption.text;
    }

});